import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    products:[],
    product: null,
    categories: [],
    category: null,
    filteredProducts: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function productReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
    
        case Constants.RESET_PRODUCT:
            newState = { ...state };
            newState.product = null;
            newState.filteredProducts = [];
            return newState;

        case Constants.RESET_PRODUCTS:
            newState = { ...state };
            newState.products = [];
            newState.filteredProducts = [];
            return newState;

        case Constants.REQUEST_ADD_CATEGORY:
        case Constants.REQUEST_ADD_PRODUCT:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;
            
        case Constants.SUCCESS_ADD_CATEGORY:
        case Constants.SUCCESS_ADD_PRODUCT:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;
            
        case Constants.SUCCESS_FILTERED_PRODUCTS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredProducts = action.filteredProducts;
            return newState;
            
        case Constants.FAILED_ADD_CATEGORY:
        case Constants.FAILED_ADD_PRODUCT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_PRODUCTS:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.FAILED_GET_PRODUCTS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_GET_PRODUCTS:
             
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            if (action.products) {
                newState.products = action.products.items;
                newState.page = action.products.page;
                newState.pageSize = action.products.pageSize;
                newState.count = action.products.totalCount;
            } else {
                newState.product = action.product;
            }
            return newState;
            
        case Constants.SUCCESS_GET_CATEGORIES:
            newState = {...state};
            newState.categories = action.payload;
            return newState;

        case Constants.SUCCESS_GET_CATEGORY:
            newState = {...state};
            newState.category = action.payload;
            return newState;
            
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ProductReducer.js